var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDelete = function SvgIconDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 5v1h8.5a1.5 1.5 0 0 1 0 3h-25a1.5 1.5 0 1 1 0-3H16V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9 13.1a1.1 1.1 0 0 1 1.1-1.1h19.8a1.1 1.1 0 0 1 1.1 1.1v19.7a2.2 2.2 0 0 1-2.2 2.2H11.2A2.2 2.2 0 0 1 9 32.8zm6 6.4a1.5 1.5 0 0 1 3 0v8a1.5 1.5 0 0 1-3 0zm8.5-1.5a1.5 1.5 0 0 0-1.5 1.5v8a1.5 1.5 0 0 0 3 0v-8a1.5 1.5 0 0 0-1.5-1.5",
    clipRule: "evenodd"
  })));
};
export default SvgIconDelete;